export const ITEM_HANDLER = 'ITEM_HANDLER';
export const is_PURCHASABLE = 'isPURCHASABLE';
export const SET_INGREDIENTS = 'SET_INGREDIENTS';
export const NO_INGREDIENTS ='NO_INGREDIENTS';

export const ORDER_SUCCESS = 'ORDER_SUCESS';
export const ORDER_FAILURE = 'ORDER_FAILURE';
export const ORDER_START = 'ORDER_START';
export const ORDER_PURCHASED_SUCCESSFULLY = 'ORDER_PURCHASED_SUCCESSFULLY';

export const FETCH_ORDER_SUCCESS = "FETCH_ORDER_SUCCESS";
export const FETCH_ORDER_FAIL = "FETCH_ORDER_FAIL";
export const FETCH_ORDER_START = "FETCH_ORDER_START";
export const DELETE_ORDER = "DELETE_ORDER";

export const SIGN_IN_SUCCESS = "SIGN_IN_SUCCESS";
export const SIGN_IN_FAIL = "SIGN_IN_FAIL";
export const SIGN_IN_START = "SIGN_IN_START";

export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_REDIRECT = 'AUTH_REDIRECT';




// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js